export const defaultRecipes = [
  {
    id: 'RECIPE-HOUSE-001',
    name: 'Italian Vinaigrette',
    category: 'Subrecipe',
    subcategory: 'Dressing',
    yield: 32,
    yieldUnit: 'oz',
    portionSize: '1 oz',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Refrigerated, shake before use',
    allergens: [],
    equipment: ['Whisk', 'Mixing bowl', 'Squeeze bottle'],
    ingredients: [
      { id: 1, ingredientId: 'S313', name: 'Oil, Olive/Canola Blend', amount: 24, unit: 'oz', vendor: 'Sysco', unitPrice: 0.12, epCost: '2.88' },
      { id: 2, ingredientId: 'S115', name: 'Vinegar, Red Wine', amount: 8, unit: 'oz', vendor: 'Sysco', unitPrice: 0.15, epCost: '1.20' },
      { id: 3, ingredientId: 'S312', name: 'Italian Seasoning', amount: 1, unit: 'tbsp', weightOz: 0.176, vendor: 'Sysco', unitPrice: 0.67, epCost: '0.12' },
      { id: 4, ingredientId: 'S120', name: 'Salt, Kosher', amount: 0.5, unit: 'tbsp', weightOz: 0.30, vendor: 'Sysco', unitPrice: 0.07, epCost: '0.02' },
      { id: 5, ingredientId: 'S122', name: 'Pepper, Black Ground', amount: 0.25, unit: 'tbsp', weightOz: 0.06, vendor: 'Sysco', unitPrice: 0.45, epCost: '0.03' }
    ],
    instructions: [
      { id: 1, title: 'Combine Seasonings', details: 'Whisk together red wine vinegar, Italian seasoning, salt, and pepper in a mixing bowl until salt dissolves.' },
      { id: 2, title: 'Emulsify', details: 'Slowly drizzle in oil blend while whisking constantly until fully emulsified.' },
      { id: 3, title: 'Rest & Store', details: 'Let sit 15 minutes for flavors to develop. Transfer to squeeze bottles. Refrigerate up to 2 weeks. Shake well before each use.' }
    ],
    totalCost: 4.25,
    costPerPortion: 0.13,
    foodCostPercent: 'NA',
    createdDate: '2024-12-16T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: true
  },
  {
    id: 'RECIPE-HOUSE-002',
    name: 'Basil Pesto',
    category: 'Subrecipe',
    subcategory: 'Sauce',
    yield: 16,
    yieldUnit: 'oz',
    portionSize: '1 oz',
    prepTime: '10 min',
    cookTime: '0 min',
    holdingStyle: 'Refrigerated, covered with oil film',
    allergens: ['Tree Nuts', 'Milk'],
    equipment: ['Food processor', 'Rubber spatula'],
    ingredients: [
      { id: 1, ingredientId: 'S060', name: 'Basil, Fresh', amount: 4, unit: 'oz', vendor: 'Sysco', unitPrice: 0.94, epCost: '3.76' },
      { id: 2, ingredientId: 'S280', name: 'Pine Nuts', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 1.56, epCost: '3.12' },
      { id: 3, ingredientId: 'S091', name: 'Cheese, Parmesan Shredded', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.36, epCost: '0.72' },
      { id: 4, ingredientId: 'S024', name: 'Garlic', amount: 3, unit: 'cloves', vendor: 'Sysco', unitPrice: 0.15, epCost: '0.45' },
      { id: 5, ingredientId: 'S272', name: 'Oil, Extra Virgin Olive', amount: 6, unit: 'oz', vendor: 'Sysco', unitPrice: 0.46, epCost: '2.76' },
      { id: 6, ingredientId: 'S120', name: 'Salt, Kosher', amount: 0.25, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.02' },
      { id: 7, ingredientId: 'S122', name: 'Pepper, Black Ground', amount: 0.125, unit: 'oz', vendor: 'Sysco', unitPrice: 0.45, epCost: '0.06' }
    ],
    instructions: [
      { id: 1, title: 'Toast Pine Nuts', details: 'Lightly toast pine nuts in dry pan until golden. Cool completely.' },
      { id: 2, title: 'Process Base', details: 'Add basil, garlic, and pine nuts to food processor. Pulse until coarsely chopped.' },
      { id: 3, title: 'Add Cheese', details: 'Add Parmesan and pulse to combine.' },
      { id: 4, title: 'Emulsify', details: 'With processor running, slowly drizzle in olive oil until smooth.' },
      { id: 5, title: 'Season & Store', details: 'Season with salt and pepper. Transfer to container, top with thin layer of oil to prevent browning. Refrigerate up to 1 week.' }
    ],
    totalCost: 10.89,
    costPerPortion: 0.68,
    foodCostPercent: 'NA',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: true
  },
  {
    id: 'RECIPE-HOUSE-003',
    name: 'Garlic Aioli',
    category: 'Subrecipe',
    subcategory: 'Sauce',
    yield: 16,
    yieldUnit: 'oz',
    portionSize: '1 oz',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Refrigerated',
    allergens: ['Eggs'],
    equipment: ['Food processor', 'Rubber spatula'],
    ingredients: [
      { id: 1, ingredientId: 'S261', name: 'Mayonnaise', amount: 14, unit: 'oz', vendor: 'Sysco', unitPrice: 0.11, epCost: '1.54' },
      { id: 2, ingredientId: 'S024', name: 'Garlic', amount: 4, unit: 'cloves', vendor: 'Sysco', unitPrice: 0.15, epCost: '0.60' },
      { id: 3, ingredientId: 'S120', name: 'Salt, Kosher', amount: 0.25, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.02' },
      { id: 4, ingredientId: 'S122', name: 'Pepper, Black Ground', amount: 0.125, unit: 'oz', vendor: 'Sysco', unitPrice: 0.45, epCost: '0.06' }
    ],
    instructions: [
      { id: 1, title: 'Prep Garlic', details: 'Mince garlic very finely or use microplane to create paste.' },
      { id: 2, title: 'Combine', details: 'Mix mayonnaise with garlic paste, salt, and pepper until smooth.' },
      { id: 3, title: 'Rest & Store', details: 'Refrigerate at least 30 minutes for flavors to develop. Store up to 1 week.' }
    ],
    totalCost: 2.22,
    costPerPortion: 0.14,
    foodCostPercent: 'NA',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: true
  },
  {
    id: 'RECIPE-SAND-001',
    name: 'Chicken Artichoke Pesto',
    category: 'Sandwiches and Wraps',
    subcategory: 'Sandwich',
    yield: 1,
    yieldUnit: 'sandwich',
    portionSize: '1 sandwich',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Wheat', 'Milk', 'Tree Nuts'],
    equipment: ['Cutting board', 'Knife', 'Grill/Flat-top'],
    ingredients: [
      { id: 1, ingredientId: 'S308', name: 'Ciabatta Roll', amount: 1, unit: 'ea', vendor: 'Sysco', unitPrice: 0.75, epCost: '0.75' },
      { id: 2, ingredientId: 'S080', name: 'Chicken, Breast (grilled, sliced)', amount: 4, unit: 'oz', vendor: 'Sysco', unitPrice: 0.24, epCost: '0.96' },
      { id: 3, ingredientId: 'S043', name: 'Spinach', amount: 1, unit: 'oz', vendor: 'Sysco', unitPrice: 0.18, epCost: '0.18' },
      { id: 4, ingredientId: 'S303', name: 'Cheese, Provolone', amount: 1.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.375, epCost: '0.56' },
      { id: 5, ingredientId: 'S301', name: 'Artichoke Hearts, Marinated', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.62, epCost: '1.24' },
      { id: 6, ingredientId: 'S302', name: 'Tomatoes, Sun-Dried', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.90, epCost: '0.45' },
      { id: 7, ingredientId: 'RECIPE-HOUSE-002', name: 'Basil Pesto', amount: 1, unit: 'oz', isSubRecipe: true, unitPrice: 0.68, epCost: '0.68' }
    ],
    instructions: [
      { id: 1, title: 'Prep Roll', details: 'Slice ciabatta roll horizontally. Toast lightly.' },
      { id: 2, title: 'Spread Pesto', details: 'Spread Basil Pesto on both cut sides of roll.' },
      { id: 3, title: 'Layer Chicken', details: 'Place sliced grilled chicken on bottom half.' },
      { id: 4, title: 'Add Cheese & Veg', details: 'Layer provolone, artichoke hearts, sun-dried tomatoes, and spinach.' },
      { id: 5, title: 'Close & Cut', details: 'Top with roll, press gently, cut in half diagonally.' }
    ],
    totalCost: 4.82,
    costPerPortion: 4.82,
    foodCostPercent: 30.2,
    suggestedMenuPrice: '15.95',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  },
  {
    id: 'RECIPE-SAND-002',
    name: 'Rustic Italian',
    category: 'Sandwiches and Wraps',
    subcategory: 'Sandwich',
    yield: 1,
    yieldUnit: 'sandwich',
    portionSize: '1 sandwich',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Wheat', 'Milk', 'Eggs'],
    equipment: ['Cutting board', 'Knife'],
    ingredients: [
      { id: 1, ingredientId: 'S308', name: 'Ciabatta Roll', amount: 1, unit: 'ea', vendor: 'Sysco', unitPrice: 0.75, epCost: '0.75' },
      { id: 2, ingredientId: 'S304', name: 'Ham, Black Forest', amount: 3, unit: 'oz', vendor: 'Sysco', unitPrice: 0.375, epCost: '1.13' },
      { id: 3, ingredientId: 'S305', name: 'Salami, Genoa', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.44, epCost: '0.88' },
      { id: 4, ingredientId: 'S303', name: 'Cheese, Provolone', amount: 1.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.375, epCost: '0.56' },
      { id: 5, ingredientId: 'S306', name: 'Pepperoncini', amount: 1, unit: 'oz', vendor: 'Sysco', unitPrice: 0.08, epCost: '0.08' },
      { id: 6, ingredientId: 'S044', name: 'Lettuce, Romaine (shredded)', amount: 1, unit: 'oz', vendor: 'Sysco', unitPrice: 0.08, epCost: '0.08' },
      { id: 7, ingredientId: 'S034', name: 'Tomato, Roma (sliced)', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.14' },
      { id: 8, ingredientId: 'S021', name: 'Onion, Red (sliced thin)', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.05, epCost: '0.03' },
      { id: 9, ingredientId: 'RECIPE-HOUSE-003', name: 'Garlic Aioli', amount: 1, unit: 'oz', isSubRecipe: true, unitPrice: 0.14, epCost: '0.14' }
    ],
    instructions: [
      { id: 1, title: 'Prep Roll', details: 'Slice ciabatta roll horizontally. Toast lightly if desired.' },
      { id: 2, title: 'Spread Aioli', details: 'Spread Garlic Aioli on both cut sides of roll.' },
      { id: 3, title: 'Layer Meats', details: 'Shingle ham and salami on bottom half of roll.' },
      { id: 4, title: 'Add Cheese', details: 'Layer provolone over meats.' },
      { id: 5, title: 'Top with Vegetables', details: 'Add shredded lettuce, sliced tomato, red onion, and pepperoncini.' },
      { id: 6, title: 'Close & Cut', details: 'Place top of roll, press gently, cut in half diagonally.' }
    ],
    totalCost: 3.79,
    costPerPortion: 3.79,
    foodCostPercent: 29.3,
    suggestedMenuPrice: '12.95',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  },
  {
    id: 'RECIPE-SAND-003',
    name: 'Four Seasons Caprese',
    category: 'Sandwiches and Wraps',
    subcategory: 'Sandwich',
    yield: 1,
    yieldUnit: 'sandwich',
    portionSize: '1 sandwich',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Wheat', 'Milk', 'Tree Nuts'],
    equipment: ['Cutting board', 'Knife'],
    ingredients: [
      { id: 1, ingredientId: 'S308', name: 'Ciabatta Roll', amount: 1, unit: 'ea', vendor: 'Sysco', unitPrice: 0.75, epCost: '0.75' },
      { id: 2, ingredientId: 'S310', name: 'Mozzarella, Fresh (sliced)', amount: 4, unit: 'oz', vendor: 'Sysco', unitPrice: 0.56, epCost: '2.24' },
      { id: 3, ingredientId: 'S034', name: 'Tomato, Roma (sliced)', amount: 3, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.21' },
      { id: 4, ingredientId: 'S300', name: 'Arugula', amount: 0.75, unit: 'oz', vendor: 'Sysco', unitPrice: 0.13, epCost: '0.10' },
      { id: 5, ingredientId: 'RECIPE-HOUSE-002', name: 'Basil Pesto', amount: 1, unit: 'oz', isSubRecipe: true, unitPrice: 0.68, epCost: '0.68' },
      { id: 6, ingredientId: 'S314', name: 'Balsamic Glaze', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.67, epCost: '0.34' }
    ],
    instructions: [
      { id: 1, title: 'Prep Roll', details: 'Slice ciabatta roll horizontally. Toast lightly.' },
      { id: 2, title: 'Spread Pesto', details: 'Spread Basil Pesto on bottom half of roll.' },
      { id: 3, title: 'Layer Caprese', details: 'Alternate slices of fresh mozzarella and Roma tomato.' },
      { id: 4, title: 'Add Arugula', details: 'Top with fresh arugula.' },
      { id: 5, title: 'Drizzle & Close', details: 'Drizzle balsamic glaze over arugula. Top with roll, press gently, cut in half diagonally.' }
    ],
    totalCost: 4.32,
    costPerPortion: 4.32,
    foodCostPercent: 28.9,
    suggestedMenuPrice: '14.95',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  },
  {
    id: 'RECIPE-WRAP-001',
    name: 'Grilled Chicken Caesar Wrap',
    category: 'Sandwiches and Wraps',
    subcategory: 'Wrap',
    yield: 1,
    yieldUnit: 'wrap',
    portionSize: '1 wrap',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Wheat', 'Milk', 'Eggs'],
    equipment: ['Cutting board', 'Knife', 'Grill/Flat-top'],
    ingredients: [
      { id: 1, ingredientId: 'S317', name: 'Tortilla, Garlic Herb 12in', amount: 1, unit: 'ea', vendor: 'Sysco', unitPrice: 0.29, epCost: '0.29' },
      { id: 2, ingredientId: 'S080', name: 'Chicken, Breast (grilled, sliced)', amount: 4, unit: 'oz', vendor: 'Sysco', unitPrice: 0.24, epCost: '0.96' },
      { id: 3, ingredientId: 'S091', name: 'Cheese, Parmesan Shredded', amount: 1, unit: 'oz', vendor: 'Sysco', unitPrice: 0.36, epCost: '0.36' },
      { id: 4, ingredientId: 'S044', name: 'Lettuce, Romaine (shredded)', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.08, epCost: '0.16' },
      { id: 5, ingredientId: 'S318', name: 'Italian Dressing', amount: 1.5, unit: 'oz', vendor: 'Costco', unitPrice: 0.18, epCost: '0.27' }
    ],
    instructions: [
      { id: 1, title: 'Prep Chicken', details: 'Grill chicken breast, slice into strips.' },
      { id: 2, title: 'Warm Tortilla', details: 'Briefly heat tortilla on flat-top to make pliable.' },
      { id: 3, title: 'Dress Lettuce', details: 'Toss shredded romaine with Italian dressing.' },
      { id: 4, title: 'Assemble', details: 'Layer dressed lettuce, chicken, and parmesan in center of tortilla.' },
      { id: 5, title: 'Roll & Cut', details: 'Fold sides in, roll tightly from bottom. Cut in half on diagonal.' }
    ],
    totalCost: 2.04,
    costPerPortion: 2.04,
    foodCostPercent: 29.4,
    suggestedMenuPrice: '6.95',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  },
  {
    id: 'RECIPE-WRAP-002',
    name: 'Turkey Provolone Wrap',
    category: 'Sandwiches and Wraps',
    subcategory: 'Wrap',
    yield: 1,
    yieldUnit: 'wrap',
    portionSize: '1 wrap',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Wheat', 'Milk', 'Eggs'],
    equipment: ['Cutting board', 'Knife'],
    ingredients: [
      { id: 1, ingredientId: 'S317', name: 'Tortilla, Garlic Herb 12in', amount: 1, unit: 'ea', vendor: 'Sysco', unitPrice: 0.29, epCost: '0.29' },
      { id: 2, ingredientId: 'S319', name: 'Turkey Breast, Sliced', amount: 4, unit: 'oz', vendor: 'Costco', unitPrice: 0.77, epCost: '3.08' },
      { id: 3, ingredientId: 'S303', name: 'Cheese, Provolone', amount: 1.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.375, epCost: '0.56' },
      { id: 4, ingredientId: 'S034', name: 'Tomato, Roma (sliced)', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.14' },
      { id: 5, ingredientId: 'S046', name: 'Lettuce, Spring Mix', amount: 1, unit: 'oz', vendor: 'Sysco', unitPrice: 0.28, epCost: '0.28' },
      { id: 6, ingredientId: 'S261', name: 'Mayonnaise', amount: 1, unit: 'oz', vendor: 'Sysco', unitPrice: 0.11, epCost: '0.11' }
    ],
    instructions: [
      { id: 1, title: 'Warm Tortilla', details: 'Briefly heat tortilla on flat-top to make pliable.' },
      { id: 2, title: 'Spread Mayo', details: 'Spread mayonnaise across center of tortilla.' },
      { id: 3, title: 'Layer Ingredients', details: 'Layer turkey, provolone, sliced tomato, and spring mix.' },
      { id: 4, title: 'Roll & Cut', details: 'Fold sides in, roll tightly from bottom. Cut in half on diagonal.' }
    ],
    totalCost: 4.46,
    costPerPortion: 4.46,
    foodCostPercent: 29.8,
    suggestedMenuPrice: '14.95',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  },
  {
    id: 'RECIPE-WRAP-003',
    name: 'Mediterranean Falafel Wrap (V)',
    category: 'Sandwiches and Wraps',
    subcategory: 'Wrap',
    yield: 1,
    yieldUnit: 'wrap',
    portionSize: '1 wrap',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Wheat', 'Sesame'],
    equipment: ['Cutting board', 'Knife', 'Oven/Fryer'],
    ingredients: [
      { id: 1, ingredientId: 'S317', name: 'Tortilla, Garlic Herb 12in', amount: 1, unit: 'ea', vendor: 'Sysco', unitPrice: 0.29, epCost: '0.29' },
      { id: 2, ingredientId: 'S315', name: 'Falafel Balls', amount: 3, unit: 'oz', vendor: 'Sysco', unitPrice: 0.26, epCost: '0.78' },
      { id: 3, ingredientId: 'S316', name: 'Hummus, Traditional', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.26, epCost: '0.52' },
      { id: 4, ingredientId: 'S036', name: 'Cucumber (diced)', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.14' },
      { id: 5, ingredientId: 'S032', name: 'Bell Pepper, Red (diced)', amount: 1.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.21, epCost: '0.32' },
      { id: 6, ingredientId: 'S034', name: 'Tomato, Roma (diced)', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.14' },
      { id: 7, ingredientId: 'S044', name: 'Lettuce, Romaine (shredded)', amount: 1.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.08, epCost: '0.12' }
    ],
    instructions: [
      { id: 1, title: 'Heat Falafel', details: 'Bake or fry falafel balls until heated through and crispy.' },
      { id: 2, title: 'Warm Tortilla', details: 'Briefly heat tortilla on flat-top to make pliable.' },
      { id: 3, title: 'Spread Hummus', details: 'Spread hummus across center of tortilla.' },
      { id: 4, title: 'Layer Vegetables', details: 'Add romaine, cucumber, tomato, and red bell pepper.' },
      { id: 5, title: 'Add Falafel', details: 'Place warm falafel balls on top of vegetables.' },
      { id: 6, title: 'Roll & Cut', details: 'Fold sides in, roll tightly from bottom. Cut in half on diagonal.' }
    ],
    totalCost: 2.31,
    costPerPortion: 2.31,
    foodCostPercent: 29.1,
    suggestedMenuPrice: '7.95',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  },
  {
    id: 'RECIPE-SALAD-001',
    name: 'Caesar Salad',
    category: 'Salads',
    subcategory: 'House Salad',
    yield: 1,
    yieldUnit: 'salad',
    portionSize: '1 salad',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Wheat', 'Milk', 'Eggs'],
    equipment: ['Salad bowl', 'Tongs'],
    ingredients: [
      { id: 1, ingredientId: 'S044', name: 'Lettuce, Romaine (chopped)', amount: 3, unit: 'oz', vendor: 'Sysco', unitPrice: 0.08, epCost: '0.24' },
      { id: 2, ingredientId: 'S091', name: 'Cheese, Parmesan Shredded', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.36, epCost: '0.18' },
      { id: 3, ingredientId: 'S321', name: 'Croutons, Seasoned', amount: 0.5, unit: 'oz', vendor: 'Restaurant Depot', unitPrice: 0.19, epCost: '0.10' },
      { id: 4, ingredientId: 'S318', name: 'Italian Dressing', amount: 1.5, unit: 'oz', vendor: 'Costco', unitPrice: 0.18, epCost: '0.27' }
    ],
    instructions: [
      { id: 1, title: 'Prep Greens', details: 'Chop romaine into bite-sized pieces. Place in salad bowl.' },
      { id: 2, title: 'Dress Salad', details: 'Add Italian dressing and toss to coat evenly.' },
      { id: 3, title: 'Finish', details: 'Top with shredded parmesan and croutons. Serve immediately.' }
    ],
    totalCost: 0.79,
    costPerPortion: 0.79,
    foodCostPercent: 26.3,
    suggestedMenuPrice: '2.99',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  },
  {
    id: 'RECIPE-SALAD-002',
    name: 'Greek Salad (VG)',
    category: 'Salads',
    subcategory: 'House Salad',
    yield: 1,
    yieldUnit: 'salad',
    portionSize: '1 salad',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Milk'],
    equipment: ['Salad bowl', 'Tongs', 'Cutting board', 'Knife'],
    ingredients: [
      { id: 1, ingredientId: 'S044', name: 'Lettuce, Romaine (chopped)', amount: 3, unit: 'oz', vendor: 'Sysco', unitPrice: 0.08, epCost: '0.24' },
      { id: 2, ingredientId: 'S036', name: 'Cucumber (diced)', amount: 1.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.11' },
      { id: 3, ingredientId: 'S034', name: 'Tomato, Roma (diced)', amount: 2, unit: 'oz', vendor: 'Sysco', unitPrice: 0.07, epCost: '0.14' },
      { id: 4, ingredientId: 'S021', name: 'Onion, Red (sliced thin)', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.05, epCost: '0.03' },
      { id: 5, ingredientId: 'S320', name: 'Cheese, Feta Crumbled', amount: 1, unit: 'oz', vendor: 'Costco', unitPrice: 0.32, epCost: '0.32' },
      { id: 6, ingredientId: 'S263', name: 'Olives, Kalamata', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.35, epCost: '0.18' },
      { id: 7, ingredientId: 'S306', name: 'Pepperoncini', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.08, epCost: '0.04' },
      { id: 8, ingredientId: 'S318', name: 'Italian Dressing', amount: 1.5, unit: 'oz', vendor: 'Costco', unitPrice: 0.18, epCost: '0.27' }
    ],
    instructions: [
      { id: 1, title: 'Prep Vegetables', details: 'Chop romaine, dice cucumber and tomato, thinly slice red onion.' },
      { id: 2, title: 'Build Salad', details: 'Place romaine in bowl. Top with cucumber, tomato, and red onion.' },
      { id: 3, title: 'Add Toppings', details: 'Scatter feta, kalamata olives, and pepperoncini over salad.' },
      { id: 4, title: 'Dress & Serve', details: 'Drizzle with Italian dressing. Serve immediately.' }
    ],
    totalCost: 1.33,
    costPerPortion: 1.33,
    foodCostPercent: 26.9,
    suggestedMenuPrice: '4.95',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  },
  {
    id: 'RECIPE-SALAD-003',
    name: 'Field Greens with Goat Cheese & Pecans (VG)',
    category: 'Salads',
    subcategory: 'House Salad',
    yield: 1,
    yieldUnit: 'salad',
    portionSize: '1 salad',
    prepTime: '5 min',
    cookTime: '0 min',
    holdingStyle: 'Made to order',
    allergens: ['Milk', 'Tree Nuts'],
    equipment: ['Salad bowl', 'Tongs'],
    ingredients: [
      { id: 1, ingredientId: 'S046', name: 'Lettuce, Spring Mix', amount: 2.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.28, epCost: '0.70' },
      { id: 2, ingredientId: 'S292', name: 'Cranberries, Dried', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 0.33, epCost: '0.17' },
      { id: 3, ingredientId: 'S233', name: 'Cheese, Goat', amount: 1, unit: 'oz', vendor: 'Sysco', unitPrice: 0.59, epCost: '0.59' },
      { id: 4, ingredientId: 'B052', name: 'Pecans, Halves', amount: 0.5, unit: 'oz', vendor: 'Sysco', unitPrice: 1.01, epCost: '0.51' },
      { id: 5, ingredientId: 'S318', name: 'Italian Dressing', amount: 1.5, unit: 'oz', vendor: 'Costco', unitPrice: 0.18, epCost: '0.27' }
    ],
    instructions: [
      { id: 1, title: 'Prep Greens', details: 'Place spring mix in salad bowl.' },
      { id: 2, title: 'Add Toppings', details: 'Scatter dried cranberries and pecan halves over greens.' },
      { id: 3, title: 'Add Cheese', details: 'Crumble goat cheese over salad.' },
      { id: 4, title: 'Dress & Serve', details: 'Drizzle with Italian dressing. Serve immediately.' }
    ],
    totalCost: 2.24,
    costPerPortion: 2.24,
    foodCostPercent: 28.2,
    suggestedMenuPrice: '7.95',
    createdDate: '2024-12-17T00:00:00.000Z',
    updatedDate: '2024-12-17T00:00:00.000Z',
    isSubRecipe: false
  }
];

// CUL163 - Sauces Course Recipes
// Week 1 - Stocks
export const cul163Recipes = [
  {
    id: 'CUL163-W1-001',
    name: 'White Chicken Stock',
    category: 'CUL163',
    subcategory: 'Week 1 - Stocks',
    yield: 1,
    yieldUnit: 'gal',
    portionSize: '8 oz',
    prepTime: '30 min',
    cookTime: '4 hours',
    holdingStyle: 'Refrigerate up to 5 days, freeze up to 3 months',
    allergens: [],
    equipment: ['Stock pot', 'Ladle', 'Fine mesh strainer', 'Cheesecloth'],
    ingredients: [
      { id: 1, name: 'Chicken Bones', amount: 4, unit: 'lb', unitPrice: 1.25, epCost: 5.00 },
      { id: 2, name: 'Yellow Onion, rough cut', amount: 8, unit: 'oz', unitPrice: 0.06, epCost: 0.48 },
      { id: 3, name: 'Celery, rough cut', amount: 4, unit: 'oz', unitPrice: 0.10, epCost: 0.40 },
      { id: 4, name: 'Carrots, rough cut', amount: 4, unit: 'oz', unitPrice: 0.08, epCost: 0.32 },
      { id: 5, name: 'Bay Leaves', amount: 2, unit: 'ea', unitPrice: 0.10, epCost: 0.20 },
      { id: 6, name: 'Thyme, fresh', amount: 4, unit: 'sprigs', unitPrice: 0.15, epCost: 0.60 },
      { id: 7, name: 'Parsley Stems', amount: 6, unit: 'ea', unitPrice: 0.05, epCost: 0.30 },
      { id: 8, name: 'Black Peppercorns', amount: 1, unit: 'tsp', unitPrice: 0.15, epCost: 0.15 },
      { id: 9, name: 'Cold Water', amount: 5, unit: 'qt', unitPrice: 0, epCost: 0 }
    ],
    instructions: [
      { id: 1, title: 'Rinse Bones', details: 'Rinse chicken bones under cold water to remove blood and impurities.' },
      { id: 2, title: 'Cover with Water', details: 'Place bones in stock pot and cover with cold water by 2 inches.' },
      { id: 3, title: 'Bring to Simmer', details: 'Slowly bring to a simmer over medium heat. DO NOT BOIL. Skim impurities as they rise.' },
      { id: 4, title: 'Add Mirepoix', details: 'After 2 hours, add onion, celery, and carrots.' },
      { id: 5, title: 'Add Sachet', details: 'Add bay leaves, thyme, parsley stems, and peppercorns in cheesecloth sachet.' },
      { id: 6, title: 'Simmer', details: 'Continue simmering for 2 more hours, skimming occasionally.' },
      { id: 7, title: 'Strain', details: 'Strain through fine mesh strainer lined with cheesecloth. Do not press solids.' },
      { id: 8, title: 'Cool Properly', details: 'Cool in ice bath to below 40°F within 4 hours. Refrigerate or freeze.' }
    ],
    totalCost: 7.45,
    costPerPortion: 0.58
  },
  {
    id: 'CUL163-W1-002',
    name: 'Brown Beef Stock (Estouffade)',
    category: 'CUL163',
    subcategory: 'Week 1 - Stocks',
    yield: 1,
    yieldUnit: 'gal',
    portionSize: '8 oz',
    prepTime: '45 min',
    cookTime: '8 hours',
    holdingStyle: 'Refrigerate up to 5 days, freeze up to 3 months',
    allergens: [],
    equipment: ['Roasting pan', 'Stock pot', 'Ladle', 'Fine mesh strainer'],
    ingredients: [
      { id: 1, name: 'Beef Bones', amount: 5, unit: 'lb', unitPrice: 2.50, epCost: 12.50 },
      { id: 2, name: 'Yellow Onion, rough cut', amount: 8, unit: 'oz', unitPrice: 0.06, epCost: 0.48 },
      { id: 3, name: 'Celery, rough cut', amount: 4, unit: 'oz', unitPrice: 0.10, epCost: 0.40 },
      { id: 4, name: 'Carrots, rough cut', amount: 4, unit: 'oz', unitPrice: 0.08, epCost: 0.32 },
      { id: 5, name: 'Tomato Paste', amount: 2, unit: 'oz', unitPrice: 0.25, epCost: 0.50 },
      { id: 6, name: 'Bay Leaves', amount: 2, unit: 'ea', unitPrice: 0.10, epCost: 0.20 },
      { id: 7, name: 'Thyme, fresh', amount: 4, unit: 'sprigs', unitPrice: 0.15, epCost: 0.60 },
      { id: 8, name: 'Black Peppercorns', amount: 1, unit: 'tsp', unitPrice: 0.15, epCost: 0.15 }
    ],
    instructions: [
      { id: 1, title: 'Roast Bones', details: 'Roast bones at 400°F until deeply browned, about 45 minutes. Turn halfway.' },
      { id: 2, title: 'Roast Mirepoix', details: 'Add mirepoix and tomato paste to pan. Roast 15 more minutes until caramelized.' },
      { id: 3, title: 'Deglaze Pan', details: 'Transfer to stock pot. Deglaze roasting pan with water, scraping fond.' },
      { id: 4, title: 'Cover and Simmer', details: 'Cover bones with cold water. Bring to simmer slowly. Never boil.' },
      { id: 5, title: 'Skim and Simmer', details: 'Skim impurities. Simmer 6-8 hours, adding water as needed to keep bones covered.' },
      { id: 6, title: 'Add Sachet', details: 'Add sachet in last 2 hours of cooking.' },
      { id: 7, title: 'Strain and Cool', details: 'Strain through cheesecloth. Cool rapidly in ice bath.' }
    ],
    totalCost: 15.15,
    costPerPortion: 1.18
  },
  {
    id: 'CUL163-W1-003',
    name: 'Fish Fumet',
    category: 'CUL163',
    subcategory: 'Week 1 - Stocks',
    yield: 1,
    yieldUnit: 'gal',
    portionSize: '8 oz',
    prepTime: '20 min',
    cookTime: '45 min',
    holdingStyle: 'Refrigerate up to 2 days, freeze up to 2 months',
    allergens: ['Fish'],
    equipment: ['Stock pot', 'Fine mesh strainer', 'Cheesecloth'],
    ingredients: [
      { id: 1, name: 'Fish Bones/Frames (white fish)', amount: 4, unit: 'lb', unitPrice: 2.00, epCost: 8.00 },
      { id: 2, name: 'Yellow Onion, sliced thin', amount: 6, unit: 'oz', unitPrice: 0.06, epCost: 0.36 },
      { id: 3, name: 'Celery, sliced thin', amount: 3, unit: 'oz', unitPrice: 0.10, epCost: 0.30 },
      { id: 4, name: 'Leeks, white part sliced', amount: 3, unit: 'oz', unitPrice: 0.25, epCost: 0.75 },
      { id: 5, name: 'White Wine', amount: 8, unit: 'oz', unitPrice: 0.50, epCost: 4.00 },
      { id: 6, name: 'Parsley Stems', amount: 6, unit: 'ea', unitPrice: 0.05, epCost: 0.30 },
      { id: 7, name: 'Lemon, sliced', amount: 0.5, unit: 'ea', unitPrice: 0.50, epCost: 0.25 },
      { id: 8, name: 'White Peppercorns', amount: 0.5, unit: 'tsp', unitPrice: 0.20, epCost: 0.10 }
    ],
    instructions: [
      { id: 1, title: 'Prepare Bones', details: 'Rinse fish bones thoroughly. Remove gills and any blood. Chop into 3-inch pieces.' },
      { id: 2, title: 'Sweat Aromatics', details: 'Sweat onion, celery, and leeks in butter until soft. Do not brown.' },
      { id: 3, title: 'Add Bones', details: 'Add fish bones. Sweat 5 minutes until bones turn opaque.' },
      { id: 4, title: 'Deglaze', details: 'Add white wine. Reduce by half.' },
      { id: 5, title: 'Add Water', details: 'Add cold water to cover by 1 inch. Add parsley, lemon, peppercorns.' },
      { id: 6, title: 'Simmer Briefly', details: 'Bring to simmer. Cook ONLY 30-45 minutes. Longer makes it bitter.' },
      { id: 7, title: 'Strain Gently', details: 'Strain through cheesecloth without pressing. Cool immediately.' }
    ],
    totalCost: 14.06,
    costPerPortion: 1.10
  },
  {
    id: 'CUL163-W1-004',
    name: 'Vegetable Stock',
    category: 'CUL163',
    subcategory: 'Week 1 - Stocks',
    yield: 1,
    yieldUnit: 'gal',
    portionSize: '8 oz',
    prepTime: '20 min',
    cookTime: '1 hour',
    holdingStyle: 'Refrigerate up to 5 days, freeze up to 3 months',
    allergens: [],
    equipment: ['Stock pot', 'Fine mesh strainer'],
    ingredients: [
      { id: 1, name: 'Yellow Onion, rough cut', amount: 12, unit: 'oz', unitPrice: 0.06, epCost: 0.72 },
      { id: 2, name: 'Celery, rough cut', amount: 8, unit: 'oz', unitPrice: 0.10, epCost: 0.80 },
      { id: 3, name: 'Carrots, rough cut', amount: 8, unit: 'oz', unitPrice: 0.08, epCost: 0.64 },
      { id: 4, name: 'Leeks, rough cut', amount: 4, unit: 'oz', unitPrice: 0.25, epCost: 1.00 },
      { id: 5, name: 'Mushroom Stems', amount: 4, unit: 'oz', unitPrice: 0.30, epCost: 1.20 },
      { id: 6, name: 'Garlic, crushed', amount: 4, unit: 'cloves', unitPrice: 0.10, epCost: 0.40 },
      { id: 7, name: 'Bay Leaves', amount: 2, unit: 'ea', unitPrice: 0.10, epCost: 0.20 },
      { id: 8, name: 'Thyme, fresh', amount: 4, unit: 'sprigs', unitPrice: 0.15, epCost: 0.60 },
      { id: 9, name: 'Parsley Stems', amount: 8, unit: 'ea', unitPrice: 0.05, epCost: 0.40 }
    ],
    instructions: [
      { id: 1, title: 'Sweat Vegetables', details: 'Sweat all vegetables in a little oil until softened, about 10 minutes.' },
      { id: 2, title: 'Add Water', details: 'Add cold water to cover vegetables by 2 inches.' },
      { id: 3, title: 'Add Aromatics', details: 'Add bay leaves, thyme, and parsley stems.' },
      { id: 4, title: 'Simmer', details: 'Bring to simmer. Cook 45 minutes to 1 hour. Do not overcook.' },
      { id: 5, title: 'Strain', details: 'Strain through fine mesh strainer. Press vegetables lightly.' },
      { id: 6, title: 'Cool', details: 'Cool rapidly and refrigerate or freeze.' }
    ],
    totalCost: 5.96,
    costPerPortion: 0.47
  },

  // Week 2 - Espagnole & Demi-Glace
  {
    id: 'CUL163-W2-001',
    name: 'Espagnole (Brown Mother Sauce)',
    category: 'CUL163',
    subcategory: 'Week 2 - Espagnole',
    yield: 1,
    yieldUnit: 'gal',
    portionSize: '2 oz',
    prepTime: '30 min',
    cookTime: '4 hours',
    holdingStyle: 'Refrigerate up to 5 days, freeze up to 2 months',
    allergens: ['Wheat'],
    equipment: ['Heavy-bottom sauce pot', 'Whisk', 'Ladle', 'Fine mesh strainer'],
    ingredients: [
      { id: 1, name: 'Brown Veal Stock', amount: 1.25, unit: 'gal', unitPrice: 8.00, epCost: 10.00 },
      { id: 2, name: 'Clarified Butter', amount: 6, unit: 'oz', unitPrice: 0.50, epCost: 3.00 },
      { id: 3, name: 'All Purpose Flour', amount: 6, unit: 'oz', unitPrice: 0.04, epCost: 0.24 },
      { id: 4, name: 'Yellow Onion, medium dice', amount: 6, unit: 'oz', unitPrice: 0.06, epCost: 0.36 },
      { id: 5, name: 'Carrots, medium dice', amount: 3, unit: 'oz', unitPrice: 0.08, epCost: 0.24 },
      { id: 6, name: 'Celery, medium dice', amount: 3, unit: 'oz', unitPrice: 0.10, epCost: 0.30 },
      { id: 7, name: 'Tomato Paste', amount: 3, unit: 'oz', unitPrice: 0.25, epCost: 0.75 },
      { id: 8, name: 'Bacon, diced', amount: 4, unit: 'oz', unitPrice: 0.50, epCost: 2.00 },
      { id: 9, name: 'Sachet (bay, thyme, parsley, peppercorns)', amount: 1, unit: 'ea', unitPrice: 0.50, epCost: 0.50 }
    ],
    instructions: [
      { id: 1, title: 'Render Bacon', details: 'Cook bacon until fat is rendered and bacon is crisp. Remove bacon bits.' },
      { id: 2, title: 'Caramelize Mirepoix', details: 'Add mirepoix to bacon fat. Cook until deeply caramelized, stirring occasionally.' },
      { id: 3, title: 'Add Tomato Paste', details: 'Add tomato paste. Cook until it turns brick red (pincé), about 3 minutes.' },
      { id: 4, title: 'Make Brown Roux', details: 'In separate pan, make brown roux with butter and flour. Cook to dark brown color.' },
      { id: 5, title: 'Combine', details: 'Add hot stock to roux gradually, whisking constantly to prevent lumps.' },
      { id: 6, title: 'Add Mirepoix', details: 'Add caramelized mirepoix and sachet to sauce.' },
      { id: 7, title: 'Simmer', details: 'Simmer 3-4 hours, skimming frequently. Sauce should reduce by about 1/3.' },
      { id: 8, title: 'Strain', details: 'Strain through fine mesh strainer. Adjust seasoning. Cool properly.' }
    ],
    totalCost: 17.39,
    costPerPortion: 0.27
  },
  {
    id: 'CUL163-W2-002',
    name: 'Demi-Glace',
    category: 'CUL163',
    subcategory: 'Week 2 - Espagnole',
    yield: 1,
    yieldUnit: 'qt',
    portionSize: '1 oz',
    prepTime: '15 min',
    cookTime: '2 hours',
    holdingStyle: 'Refrigerate up to 1 week, freeze up to 3 months',
    allergens: ['Wheat'],
    equipment: ['Heavy sauce pot', 'Ladle', 'Fine mesh strainer'],
    ingredients: [
      { id: 1, name: 'Espagnole', amount: 1, unit: 'qt', unitPrice: 4.35, epCost: 4.35 },
      { id: 2, name: 'Brown Veal Stock', amount: 1, unit: 'qt', unitPrice: 8.00, epCost: 8.00 }
    ],
    instructions: [
      { id: 1, title: 'Combine', details: 'Combine equal parts Espagnole and brown stock in heavy pot.' },
      { id: 2, title: 'Reduce', details: 'Simmer until reduced by half, skimming frequently.' },
      { id: 3, title: 'Test Consistency', details: 'Sauce should coat a spoon and have rich, glossy appearance.' },
      { id: 4, title: 'Strain', details: 'Strain through fine mesh strainer.' },
      { id: 5, title: 'Monte au Beurre', details: 'Optional: finish with cold butter for extra richness and shine.' }
    ],
    totalCost: 12.35,
    costPerPortion: 0.39
  },
  {
    id: 'CUL163-W2-003',
    name: 'Sauce Bordelaise',
    category: 'CUL163',
    subcategory: 'Week 2 - Espagnole',
    yield: 1,
    yieldUnit: 'pt',
    portionSize: '2 oz',
    prepTime: '15 min',
    cookTime: '30 min',
    holdingStyle: 'Hold warm, use within 2 hours',
    allergens: ['Wheat'],
    equipment: ['Saucepan', 'Fine mesh strainer'],
    ingredients: [
      { id: 1, name: 'Demi-Glace', amount: 2, unit: 'cups', unitPrice: 3.09, epCost: 6.18 },
      { id: 2, name: 'Red Wine (Bordeaux style)', amount: 1, unit: 'cup', unitPrice: 2.00, epCost: 2.00 },
      { id: 3, name: 'Shallots, minced', amount: 2, unit: 'oz', unitPrice: 0.35, epCost: 0.70 },
      { id: 4, name: 'Thyme, fresh', amount: 2, unit: 'sprigs', unitPrice: 0.15, epCost: 0.30 },
      { id: 5, name: 'Bay Leaf', amount: 1, unit: 'ea', unitPrice: 0.10, epCost: 0.10 },
      { id: 6, name: 'Bone Marrow, poached and diced', amount: 2, unit: 'oz', unitPrice: 1.00, epCost: 2.00 },
      { id: 7, name: 'Butter, cold', amount: 1, unit: 'oz', unitPrice: 0.35, epCost: 0.35 },
      { id: 8, name: 'Parsley, chopped', amount: 1, unit: 'tbsp', unitPrice: 0.10, epCost: 0.10 }
    ],
    instructions: [
      { id: 1, title: 'Reduce Wine', details: 'Simmer wine with shallots, thyme, and bay leaf until reduced by 2/3.' },
      { id: 2, title: 'Add Demi-Glace', details: 'Add demi-glace. Simmer 15-20 minutes.' },
      { id: 3, title: 'Strain', details: 'Strain sauce through fine mesh strainer.' },
      { id: 4, title: 'Finish', details: 'Monte au beurre. Add poached bone marrow and parsley.' },
      { id: 5, title: 'Serve', details: 'Serve immediately with grilled beef.' }
    ],
    totalCost: 11.73,
    costPerPortion: 1.47
  },

  // Week 3 - Velouté
  {
    id: 'CUL163-W3-001',
    name: 'Chicken Velouté',
    category: 'CUL163',
    subcategory: 'Week 3 - Veloute',
    yield: 1,
    yieldUnit: 'qt',
    portionSize: '2 oz',
    prepTime: '15 min',
    cookTime: '45 min',
    holdingStyle: 'Refrigerate up to 3 days',
    allergens: ['Wheat'],
    equipment: ['Heavy sauce pot', 'Whisk', 'Fine mesh strainer'],
    ingredients: [
      { id: 1, name: 'Chicken Stock', amount: 1.25, unit: 'qt', unitPrice: 1.50, epCost: 1.88 },
      { id: 2, name: 'Butter', amount: 3, unit: 'oz', unitPrice: 0.35, epCost: 1.05 },
      { id: 3, name: 'All Purpose Flour', amount: 3, unit: 'oz', unitPrice: 0.04, epCost: 0.12 },
      { id: 4, name: 'Salt', amount: 0.5, unit: 'tsp', unitPrice: 0.02, epCost: 0.01 },
      { id: 5, name: 'White Pepper', amount: 0.25, unit: 'tsp', unitPrice: 0.10, epCost: 0.03 }
    ],
    instructions: [
      { id: 1, title: 'Make Blond Roux', details: 'Melt butter, add flour. Cook to blond stage (pale yellow, nutty aroma), about 5 minutes.' },
      { id: 2, title: 'Add Stock', details: 'Gradually add hot chicken stock, whisking constantly to prevent lumps.' },
      { id: 3, title: 'Simmer', details: 'Bring to simmer. Cook 30-45 minutes, skimming surface.' },
      { id: 4, title: 'Strain', details: 'Strain through fine mesh strainer.' },
      { id: 5, title: 'Season', details: 'Season with salt and white pepper. Keep warm or cool properly.' }
    ],
    totalCost: 3.09,
    costPerPortion: 0.19
  },
  {
    id: 'CUL163-W3-002',
    name: 'Sauce Suprême',
    category: 'CUL163',
    subcategory: 'Week 3 - Veloute',
    yield: 1,
    yieldUnit: 'pt',
    portionSize: '2 oz',
    prepTime: '10 min',
    cookTime: '20 min',
    holdingStyle: 'Hold warm up to 2 hours',
    allergens: ['Wheat', 'Milk'],
    equipment: ['Saucepan', 'Whisk'],
    ingredients: [
      { id: 1, name: 'Chicken Velouté', amount: 2, unit: 'cups', unitPrice: 1.55, epCost: 3.10 },
      { id: 2, name: 'Heavy Cream', amount: 4, unit: 'oz', unitPrice: 0.28, epCost: 1.12 },
      { id: 3, name: 'Mushroom Cooking Liquid', amount: 2, unit: 'oz', unitPrice: 0.25, epCost: 0.50 },
      { id: 4, name: 'Butter, cold', amount: 1, unit: 'oz', unitPrice: 0.35, epCost: 0.35 },
      { id: 5, name: 'Lemon Juice', amount: 1, unit: 'tsp', unitPrice: 0.10, epCost: 0.10 }
    ],
    instructions: [
      { id: 1, title: 'Reduce', details: 'Simmer velouté with mushroom liquid until reduced by 1/4.' },
      { id: 2, title: 'Add Cream', details: 'Add heavy cream. Simmer until sauce coats a spoon (nappe).' },
      { id: 3, title: 'Finish', details: 'Remove from heat. Monte au beurre with cold butter.' },
      { id: 4, title: 'Season', details: 'Add lemon juice. Adjust seasoning.' }
    ],
    totalCost: 5.17,
    costPerPortion: 0.65
  },

  // Week 4 - Béchamel
  {
    id: 'CUL163-W4-001',
    name: 'Béchamel (White Mother Sauce)',
    category: 'CUL163',
    subcategory: 'Week 4 - Bechamel',
    yield: 1,
    yieldUnit: 'qt',
    portionSize: '2 oz',
    prepTime: '15 min',
    cookTime: '30 min',
    holdingStyle: 'Refrigerate up to 3 days, cover surface with butter',
    allergens: ['Wheat', 'Milk'],
    equipment: ['Heavy sauce pot', 'Whisk', 'Fine mesh strainer'],
    ingredients: [
      { id: 1, name: 'Whole Milk', amount: 1, unit: 'qt', unitPrice: 1.12, epCost: 1.12 },
      { id: 2, name: 'Butter', amount: 3, unit: 'oz', unitPrice: 0.35, epCost: 1.05 },
      { id: 3, name: 'All Purpose Flour', amount: 3, unit: 'oz', unitPrice: 0.04, epCost: 0.12 },
      { id: 4, name: 'Onion Piqué (onion with bay leaf and cloves)', amount: 1, unit: 'ea', unitPrice: 0.25, epCost: 0.25 },
      { id: 5, name: 'Salt', amount: 0.5, unit: 'tsp', unitPrice: 0.02, epCost: 0.01 },
      { id: 6, name: 'White Pepper', amount: 0.25, unit: 'tsp', unitPrice: 0.10, epCost: 0.03 },
      { id: 7, name: 'Nutmeg', amount: 0.125, unit: 'tsp', unitPrice: 0.15, epCost: 0.02 }
    ],
    instructions: [
      { id: 1, title: 'Heat Milk', details: 'Heat milk with onion piqué until steaming. Do not boil. Steep 10 minutes.' },
      { id: 2, title: 'Make White Roux', details: 'Make roux with butter and flour. Cook 3-4 minutes without coloring.' },
      { id: 3, title: 'Add Milk', details: 'Remove onion piqué. Gradually add hot milk to roux, whisking constantly.' },
      { id: 4, title: 'Simmer', details: 'Simmer 20-30 minutes, stirring frequently to prevent scorching.' },
      { id: 5, title: 'Season', details: 'Season with salt, white pepper, and nutmeg.' },
      { id: 6, title: 'Strain', details: 'Strain through fine mesh strainer. Cover surface with butter to prevent skin.' }
    ],
    totalCost: 2.60,
    costPerPortion: 0.16
  },
  {
    id: 'CUL163-W4-002',
    name: 'Sauce Mornay',
    category: 'CUL163',
    subcategory: 'Week 4 - Bechamel',
    yield: 1,
    yieldUnit: 'pt',
    portionSize: '2 oz',
    prepTime: '10 min',
    cookTime: '10 min',
    holdingStyle: 'Hold warm, use within 1 hour',
    allergens: ['Wheat', 'Milk'],
    equipment: ['Saucepan', 'Whisk'],
    ingredients: [
      { id: 1, name: 'Béchamel', amount: 2, unit: 'cups', unitPrice: 1.30, epCost: 2.60 },
      { id: 2, name: 'Gruyère, shredded', amount: 3, unit: 'oz', unitPrice: 0.88, epCost: 2.64 },
      { id: 3, name: 'Parmesan, grated', amount: 1, unit: 'oz', unitPrice: 0.75, epCost: 0.75 },
      { id: 4, name: 'Egg Yolk', amount: 1, unit: 'ea', unitPrice: 0.25, epCost: 0.25 },
      { id: 5, name: 'Cayenne', amount: 1, unit: 'pinch', unitPrice: 0.02, epCost: 0.02 }
    ],
    instructions: [
      { id: 1, title: 'Heat Béchamel', details: 'Heat béchamel over medium heat until simmering.' },
      { id: 2, title: 'Temper Yolk', details: 'Temper egg yolk with a little hot sauce, then add back to pot.' },
      { id: 3, title: 'Add Cheese', details: 'Remove from heat. Stir in cheeses until melted and smooth.' },
      { id: 4, title: 'Season', details: 'Add cayenne. Adjust seasoning.' },
      { id: 5, title: 'Use Immediately', details: 'Use immediately for gratins, or keep warm over bain-marie.' }
    ],
    totalCost: 6.26,
    costPerPortion: 0.78
  },

  // Week 5 - Tomato
  {
    id: 'CUL163-W5-001',
    name: 'Classic Tomato Sauce',
    category: 'CUL163',
    subcategory: 'Week 5 - Tomato',
    yield: 1,
    yieldUnit: 'qt',
    portionSize: '2 oz',
    prepTime: '20 min',
    cookTime: '2 hours',
    holdingStyle: 'Refrigerate up to 1 week, freeze up to 3 months',
    allergens: [],
    equipment: ['Heavy sauce pot', 'Immersion blender or food mill'],
    ingredients: [
      { id: 1, name: 'San Marzano Tomatoes, crushed', amount: 28, unit: 'oz', unitPrice: 0.16, epCost: 4.48 },
      { id: 2, name: 'Yellow Onion, small dice', amount: 4, unit: 'oz', unitPrice: 0.06, epCost: 0.24 },
      { id: 3, name: 'Carrot, small dice', amount: 2, unit: 'oz', unitPrice: 0.08, epCost: 0.16 },
      { id: 4, name: 'Celery, small dice', amount: 2, unit: 'oz', unitPrice: 0.10, epCost: 0.20 },
      { id: 5, name: 'Garlic, minced', amount: 4, unit: 'cloves', unitPrice: 0.10, epCost: 0.40 },
      { id: 6, name: 'Olive Oil', amount: 2, unit: 'oz', unitPrice: 0.25, epCost: 0.50 },
      { id: 7, name: 'Tomato Paste', amount: 2, unit: 'oz', unitPrice: 0.25, epCost: 0.50 },
      { id: 8, name: 'Fresh Basil', amount: 6, unit: 'leaves', unitPrice: 0.10, epCost: 0.60 },
      { id: 9, name: 'Bay Leaf', amount: 1, unit: 'ea', unitPrice: 0.10, epCost: 0.10 },
      { id: 10, name: 'Sugar', amount: 1, unit: 'tsp', unitPrice: 0.02, epCost: 0.02 },
      { id: 11, name: 'Salt and Pepper', amount: 1, unit: 'TT', unitPrice: 0.05, epCost: 0.05 }
    ],
    instructions: [
      { id: 1, title: 'Sweat Aromatics', details: 'Sweat onion, carrot, and celery in olive oil until softened.' },
      { id: 2, title: 'Add Garlic', details: 'Add garlic. Cook 1 minute until fragrant.' },
      { id: 3, title: 'Add Tomato Paste', details: 'Add tomato paste. Cook until brick red (pincé).' },
      { id: 4, title: 'Add Tomatoes', details: 'Add crushed tomatoes, bay leaf, and basil.' },
      { id: 5, title: 'Simmer', details: 'Simmer 1.5-2 hours until flavors meld and sauce thickens.' },
      { id: 6, title: 'Purée (Optional)', details: 'Remove bay leaf. Purée if desired for smooth sauce.' },
      { id: 7, title: 'Season', details: 'Add sugar if needed to balance acidity. Season with salt and pepper.' }
    ],
    totalCost: 7.25,
    costPerPortion: 0.45
  },

  // Week 6 - Emulsions
  {
    id: 'CUL163-W6-001',
    name: 'Hollandaise',
    category: 'CUL163',
    subcategory: 'Week 6 - Emulsions',
    yield: 2,
    yieldUnit: 'cups',
    portionSize: '2 oz',
    prepTime: '10 min',
    cookTime: '15 min',
    holdingStyle: 'Hold warm (145°F) up to 2 hours, cannot be reheated',
    allergens: ['Eggs', 'Milk'],
    equipment: ['Double boiler or bain-marie', 'Whisk', 'Ladle'],
    ingredients: [
      { id: 1, name: 'Egg Yolks', amount: 4, unit: 'ea', unitPrice: 0.25, epCost: 1.00 },
      { id: 2, name: 'Clarified Butter, warm', amount: 8, unit: 'oz', unitPrice: 0.50, epCost: 4.00 },
      { id: 3, name: 'Lemon Juice, fresh', amount: 1, unit: 'tbsp', unitPrice: 0.15, epCost: 0.15 },
      { id: 4, name: 'Water', amount: 1, unit: 'tbsp', unitPrice: 0, epCost: 0 },
      { id: 5, name: 'Cayenne', amount: 1, unit: 'pinch', unitPrice: 0.02, epCost: 0.02 },
      { id: 6, name: 'Salt', amount: 0.5, unit: 'tsp', unitPrice: 0.02, epCost: 0.01 }
    ],
    instructions: [
      { id: 1, title: 'Prepare Reduction', details: 'Optional: Make reduction with white wine vinegar, peppercorns, and shallots. Strain and cool.' },
      { id: 2, title: 'Whisk Yolks', details: 'Whisk egg yolks with water (or reduction) over double boiler until ribbon stage.' },
      { id: 3, title: 'Add Butter', details: 'Remove from heat. SLOWLY drizzle in warm clarified butter while whisking constantly.' },
      { id: 4, title: 'Season', details: 'Add lemon juice, cayenne, and salt.' },
      { id: 5, title: 'Adjust', details: 'If too thick, add a few drops of warm water. If broken, start with new yolk.' },
      { id: 6, title: 'Hold Properly', details: 'Keep warm (not hot) over barely simmering water. Use within 2 hours.' }
    ],
    totalCost: 5.18,
    costPerPortion: 0.65,
    notes: 'Temperature control is critical. Too hot = scrambled eggs. Too cold = sauce breaks.'
  },
  {
    id: 'CUL163-W6-002',
    name: 'Sauce Béarnaise',
    category: 'CUL163',
    subcategory: 'Week 6 - Emulsions',
    yield: 2,
    yieldUnit: 'cups',
    portionSize: '2 oz',
    prepTime: '15 min',
    cookTime: '20 min',
    holdingStyle: 'Hold warm up to 2 hours',
    allergens: ['Eggs', 'Milk'],
    equipment: ['Saucepan', 'Double boiler', 'Whisk', 'Fine mesh strainer'],
    ingredients: [
      { id: 1, name: 'White Wine Vinegar', amount: 0.25, unit: 'cup', unitPrice: 0.25, epCost: 0.25 },
      { id: 2, name: 'White Wine', amount: 0.25, unit: 'cup', unitPrice: 0.50, epCost: 0.50 },
      { id: 3, name: 'Shallots, minced', amount: 2, unit: 'tbsp', unitPrice: 0.35, epCost: 0.35 },
      { id: 4, name: 'Tarragon, fresh chopped', amount: 2, unit: 'tbsp', unitPrice: 0.50, epCost: 0.50 },
      { id: 5, name: 'Chervil, fresh chopped', amount: 1, unit: 'tbsp', unitPrice: 0.40, epCost: 0.40 },
      { id: 6, name: 'Black Peppercorns, crushed', amount: 1, unit: 'tsp', unitPrice: 0.15, epCost: 0.15 },
      { id: 7, name: 'Egg Yolks', amount: 4, unit: 'ea', unitPrice: 0.25, epCost: 1.00 },
      { id: 8, name: 'Clarified Butter, warm', amount: 8, unit: 'oz', unitPrice: 0.50, epCost: 4.00 },
      { id: 9, name: 'Salt', amount: 0.5, unit: 'tsp', unitPrice: 0.02, epCost: 0.01 }
    ],
    instructions: [
      { id: 1, title: 'Make Reduction', details: 'Simmer vinegar, wine, shallots, half the herbs, and peppercorns until almost dry.' },
      { id: 2, title: 'Strain', details: 'Strain reduction. Cool slightly.' },
      { id: 3, title: 'Whisk Yolks', details: 'Combine reduction with egg yolks. Whisk over double boiler to ribbon stage.' },
      { id: 4, title: 'Add Butter', details: 'Slowly incorporate warm clarified butter, whisking constantly.' },
      { id: 5, title: 'Finish', details: 'Add remaining fresh tarragon and chervil. Season with salt.' }
    ],
    totalCost: 7.16,
    costPerPortion: 0.90
  },
  {
    id: 'CUL163-W6-003',
    name: 'Mayonnaise',
    category: 'CUL163',
    subcategory: 'Week 6 - Emulsions',
    yield: 2,
    yieldUnit: 'cups',
    portionSize: '1 oz',
    prepTime: '15 min',
    cookTime: '0 min',
    holdingStyle: 'Refrigerate up to 1 week',
    allergens: ['Eggs'],
    equipment: ['Mixing bowl', 'Whisk or immersion blender'],
    ingredients: [
      { id: 1, name: 'Egg Yolks', amount: 2, unit: 'ea', unitPrice: 0.25, epCost: 0.50 },
      { id: 2, name: 'Vegetable Oil', amount: 1.5, unit: 'cups', unitPrice: 0.19, epCost: 2.85 },
      { id: 3, name: 'Dijon Mustard', amount: 1, unit: 'tsp', unitPrice: 0.10, epCost: 0.10 },
      { id: 4, name: 'Lemon Juice', amount: 1, unit: 'tbsp', unitPrice: 0.15, epCost: 0.15 },
      { id: 5, name: 'White Wine Vinegar', amount: 1, unit: 'tsp', unitPrice: 0.05, epCost: 0.05 },
      { id: 6, name: 'Salt', amount: 0.5, unit: 'tsp', unitPrice: 0.02, epCost: 0.01 },
      { id: 7, name: 'White Pepper', amount: 0.25, unit: 'tsp', unitPrice: 0.10, epCost: 0.03 }
    ],
    instructions: [
      { id: 1, title: 'Combine Base', details: 'Whisk egg yolks with mustard, vinegar, salt, and pepper until smooth.' },
      { id: 2, title: 'Add Oil Slowly', details: 'Add oil DROP BY DROP at first, whisking constantly. After emulsion forms, add in thin stream.' },
      { id: 3, title: 'Adjust', details: 'Add lemon juice. Thin with water if needed.' },
      { id: 4, title: 'Season', details: 'Adjust salt and pepper to taste.' },
      { id: 5, title: 'Store', details: 'Refrigerate immediately. Label with date.' }
    ],
    totalCost: 3.69,
    costPerPortion: 0.12
  },

  // Week 7 - Contemporary
  {
    id: 'CUL163-W7-001',
    name: 'Beurre Blanc',
    category: 'CUL163',
    subcategory: 'Week 7 - Contemporary',
    yield: 1,
    yieldUnit: 'cup',
    portionSize: '1 oz',
    prepTime: '10 min',
    cookTime: '15 min',
    holdingStyle: 'Hold warm up to 30 minutes, cannot be reheated',
    allergens: ['Milk'],
    equipment: ['Saucepan', 'Whisk'],
    ingredients: [
      { id: 1, name: 'White Wine', amount: 0.5, unit: 'cup', unitPrice: 1.00, epCost: 1.00 },
      { id: 2, name: 'White Wine Vinegar', amount: 2, unit: 'tbsp', unitPrice: 0.10, epCost: 0.10 },
      { id: 3, name: 'Shallots, minced', amount: 2, unit: 'tbsp', unitPrice: 0.35, epCost: 0.35 },
      { id: 4, name: 'Heavy Cream', amount: 2, unit: 'tbsp', unitPrice: 0.28, epCost: 0.28 },
      { id: 5, name: 'Butter, cold and cubed', amount: 8, unit: 'oz', unitPrice: 0.35, epCost: 2.80 },
      { id: 6, name: 'Salt', amount: 0.25, unit: 'tsp', unitPrice: 0.02, epCost: 0.01 },
      { id: 7, name: 'White Pepper', amount: 1, unit: 'pinch', unitPrice: 0.02, epCost: 0.02 }
    ],
    instructions: [
      { id: 1, title: 'Reduce', details: 'Simmer wine, vinegar, and shallots until almost dry (au sec).' },
      { id: 2, title: 'Add Cream', details: 'Add cream. Reduce slightly. This helps stabilize the emulsion.' },
      { id: 3, title: 'Add Butter', details: 'Over LOW heat, whisk in cold butter one cube at a time. Each cube should emulsify before adding next.' },
      { id: 4, title: 'Keep Warm', details: 'Do not let sauce get too hot or it will break. Keep between 130-140°F.' },
      { id: 5, title: 'Strain & Season', details: 'Strain out shallots if desired. Season with salt and white pepper.' }
    ],
    totalCost: 4.56,
    costPerPortion: 0.57,
    notes: 'Temperature is critical. Too hot breaks the sauce. Too cold and butter won\'t emulsify.'
  },
  {
    id: 'CUL163-W7-002',
    name: 'Gastrique',
    category: 'CUL163',
    subcategory: 'Week 7 - Contemporary',
    yield: 1,
    yieldUnit: 'cup',
    portionSize: '0.5 oz',
    prepTime: '5 min',
    cookTime: '15 min',
    holdingStyle: 'Refrigerate up to 2 weeks',
    allergens: [],
    equipment: ['Heavy saucepan'],
    ingredients: [
      { id: 1, name: 'Sugar', amount: 0.5, unit: 'cup', unitPrice: 0.10, epCost: 0.10 },
      { id: 2, name: 'Red Wine Vinegar', amount: 0.5, unit: 'cup', unitPrice: 0.50, epCost: 0.50 },
      { id: 3, name: 'Water', amount: 2, unit: 'tbsp', unitPrice: 0, epCost: 0 }
    ],
    instructions: [
      { id: 1, title: 'Make Caramel', details: 'Combine sugar with water in heavy pan. Cook without stirring until amber colored.' },
      { id: 2, title: 'Add Vinegar', details: 'CAREFULLY add vinegar (it will splatter). Stand back.' },
      { id: 3, title: 'Simmer', details: 'Simmer until reduced and syrupy.' },
      { id: 4, title: 'Cool', details: 'Cool and store. Will thicken as it cools.' }
    ],
    totalCost: 0.60,
    costPerPortion: 0.04,
    notes: 'Use as base for fruit sauces with duck, pork, or foie gras.'
  },
  {
    id: 'CUL163-W7-003',
    name: 'Compound Butter (Maître d\'Hôtel)',
    category: 'CUL163',
    subcategory: 'Week 7 - Contemporary',
    yield: 8,
    yieldUnit: 'oz',
    portionSize: '0.5 oz',
    prepTime: '10 min',
    cookTime: '0 min',
    holdingStyle: 'Refrigerate up to 2 weeks, freeze up to 2 months',
    allergens: ['Milk'],
    equipment: ['Mixing bowl', 'Plastic wrap'],
    ingredients: [
      { id: 1, name: 'Butter, softened', amount: 8, unit: 'oz', unitPrice: 0.35, epCost: 2.80 },
      { id: 2, name: 'Parsley, finely chopped', amount: 2, unit: 'tbsp', unitPrice: 0.10, epCost: 0.10 },
      { id: 3, name: 'Lemon Juice', amount: 1, unit: 'tbsp', unitPrice: 0.15, epCost: 0.15 },
      { id: 4, name: 'Lemon Zest', amount: 1, unit: 'tsp', unitPrice: 0.10, epCost: 0.10 },
      { id: 5, name: 'Salt', amount: 0.5, unit: 'tsp', unitPrice: 0.02, epCost: 0.01 },
      { id: 6, name: 'White Pepper', amount: 0.25, unit: 'tsp', unitPrice: 0.10, epCost: 0.03 }
    ],
    instructions: [
      { id: 1, title: 'Soften Butter', details: 'Allow butter to reach room temperature. Should be pliable but not melted.' },
      { id: 2, title: 'Mix', details: 'Combine butter with all ingredients. Mix thoroughly.' },
      { id: 3, title: 'Roll', details: 'Place on plastic wrap. Roll into log shape, about 1 inch diameter.' },
      { id: 4, title: 'Chill', details: 'Refrigerate until firm. Slice into rounds for service.' }
    ],
    totalCost: 3.19,
    costPerPortion: 0.20
  }
];

// Combine with existing recipes
export const allDefaultRecipes = [...defaultRecipes, ...cul163Recipes];
